import { createContext } from "react";
import { Actions } from "../actions";

// update log
// FB 4371 DK    03/29/2021    Added page to handle classes and objects
// FB 4487 DK    06/07/2021    Added a new class for error log data
// FB 4638 MS    08/31/2021    Fixed Mobile view issues
// FB 4735 DK    10/11/2021    Implementation of provider specific flow
// FB 4769 MS    11/02/2021    Added Job title for provider
// FB 4867 DK    12/27/2021    Added screens for Support files and Health forms upload
// FB 4959 MS    03/01/2022    Added condition to hide PI button for existing patients in landing page
// FB 6039 DK    06/30/2022    QR code scan changes
// FB 6963 AS    06/09/2023    renamed some fields in InputFile for clarity
// FB 7802 SK    12/14/2023    PE - Supporting Office-Specific Custom Appointment Types
// FB 7719 SK    02/14/2024    PE- option to add credit card on file while booking an appointment
// FB 8549 DK    10/21/2024    TeleHealth re-work

export type Store = {
  appointmentdetails: Appointmentdetails;
  providers: Provider[];
  facilities: Facility[];
  states: State[];
  region: FacilityRegion;
  defaultlocation: Facility;
  slotDetails: SlotDetails;
  patient: Patient;
  patientDemographics: patientDemographics; //FB 7719
  defaultprovider: Provider;		//FB 4735 DK - Added to store default provider info
};

//FB 7719 Begin
export type patientDemographics = {
  patientfirstname: string;
  patientlastname: string;
  patientDOB: Date;
  address: string
  citystatezip: string;
  cellphone: string;
  email: string;
  comments: string;
  commpref: string;
}
//FB 7719 End

export type Provider = {
  id: number;
  name: string;
  facility_n?: number;
  InsuranceAcceptance?: string;
  bio?: string;
  job_title?: string; //FB 4769
};

export type FacilityRegion = {
  id: number;
  name: string;
  state: string;
};

export type Facility = {
  id: number;
  name: string;
  address: string;
  phone?: string;
  region: number;
  InsuranceAcceptance?: string;
};

export type State = {
  name: string;
};

export type Patient = {
  name: string;
  //FB 4867 DK - Added new variables to class
  patient_n: any;
  appointment_n: any;
  patient_type: string; //FB 4959
};

export type Insurance = {
  id: number;
  name: string;
  planId: number;
  planName: string;
};

export type SlotDetails = {
  id: number;
  slotDate: Date;
  employeeId: number;
  facilityId: number;
  employeeName: string;
  facilityName: string;
  isslotexisting: boolean;
  duration: number;  //FB 4638 added appt duration
};

export type Appointmentdetails = {
  appointmenttype?: string;
  customappointmenttype?: string;//FB 7802
  appointmentfilter?: string;
  patientType: string;
  isInsuranceExist?: string;
  insurance: Insurance;
  provider: Provider;
  location: Facility;
  date: Date;
  duration: Number; //FB 4638 added appt duration
};

//FB 4487 DK - Added new class for error log data
export type ErrorLog = {
  ERROR_LOG_DATE: Date;
  ERROR_LOG_ERROR_CODE: number;
  ERROR_LOG_DESCRIPTION: string;
}

//FB 4867 DK - Added new class
export type SupportFile = {
  DocumentType: string,
  OtherDocument: string,
  FileName: string,
  FileType: string,
  FileSize: number,
  Base64EncodedFile: string,
  Appointment_N: number
}

//FB 6039
export type InputFile = {
  SESSION_N: number,		//FB 6963 renamed for clarity
  ImageId: number,
  CONTROL_NAME: string,		//FB 6963 renamed for clarity
  Image: string
}

//FB 7719 Begin
export type CreditCardPaymentModel = {
  firstNameOnCard: string;
  lastNameOnCard: string;
  PaymentToken: string;
  ValidateOrAcceptPayment: string;
  ExpirationDate: any;
  CNP: string;
  PaymentAmount: any;
  address: string;
  address2: string;
  city: string;
  state: string;
  month: string;
  year: string;
  zip: string;
  phone: string;
  email: string;
  Memo: string;
  Memo2: string;
  FeeAmount: string;
  Patient_N: number;
  SAVE_CARD: number;
  CARD_NAME: string;
  EMPLOYEE_N: number;
  COMMENT: string;
  IS_PORTAL_PAYMENT: number;// FB 7323
};
//FB 7719 End

//FB 8549
export type AppointmentType = {
  Id: number;
  NAME: string;
  COLOR: string;
  DURATION: number;
  ACTIVE_FLAG: number;
  NO_DOUBLE_BOOKING: number;
  NO_DOUBLE_BOOKING_FOR_DOCTOR: number;
  TIME_SLOT: number;
  NO_FURTHER_BOOKING: number;
  MAX_PER_HOUR: number;
  LEFT_MOST_COLUMN: number;
  MAX_PER_HALF_HOUR: number;
  IS_TELE_APPOINTMENT: number;
  IS_PE_ENABLED: number;
  ENABLE_FOR_NEW_PATIENT: number;
  ENABLE_FOR_EXISTING_PATIENT: number;
}

export const initialState: Store = {
  appointmentdetails: {
    appointmenttype: "",
    appointmentfilter: "",
    patientType: "",
    isInsuranceExist: "",
    insurance: {
      id: 0,
      planId: 0,
      name: "",
      planName: "",
    },
    provider: {
      id: 0,
      name: "",
    },
    location: {
      id: 0,
      name: "",
      address: "",
      region: 0,
    },
    date: new Date(),
    duration: 0, //FB 4638 added appt duration
  },
  providers: [],
  facilities: [],
  states: [],
  region: {
    id: 0,
    name: "",
    state: "",
  },
  defaultlocation: {
    id: 0,
    name: "",
    address: "",
    region: 0,
  },
  slotDetails: {
    employeeId: 0,

    facilityId: 0,
    id: 0,
    slotDate: new Date(),
    employeeName: "",
    facilityName: "",
    isslotexisting: false,
    duration: 0 //FB 4638 duration default vale
  },
  patient: {
    name: "",
    //FB 4867 DK - Setting initial values
    patient_n: "",
    appointment_n: "",
    patient_type: ""  //FB 4959
  },
  //FB 4735 DK - Added to store default provider info
  defaultprovider: {
    id: 0,
    name: "",
    InsuranceAcceptance: "",
    bio: "",
    job_title: ""  //FB 4769
  },
  //FB 7719 Begin
  patientDemographics: {
    patientfirstname: "",
    patientlastname: "",
    patientDOB: new Date(),
    address: "",
    citystatezip: "",
    cellphone: "",
    email: "",
    comments: "",
    commpref: "",
  }
  //FB 7719 End
};

export const Context = createContext<{
  state: Store;
  dispatch: React.Dispatch<Actions>;
}>(undefined as any);
